import { matchesSelector } from './utils';
export class ComponentInitializationError extends Error {
}
export class Component {
    constructor(el, props) {
        this.el = el;
        this.props = props;
        this.getListeners = () => [];
    }
    setup() {
        this.attachListeners();
        this.init();
    }
    getChild(selector, ChildConstructor, parent = this.el) {
        const child = parent.querySelector(selector);
        if (!(child instanceof ChildConstructor)) {
            throw new ComponentInitializationError(`The child element matching '${selector}' is not an instance of the supplied constructor.`);
        }
        return child;
    }
    getChildren(selector, parent = this.el) {
        return parent.querySelectorAll(selector);
    }
    getProp(propName) {
        return this.props[propName];
    }
    getPropOrElse(propName, defaultValue) {
        return this.props[propName] === undefined
            ? defaultValue
            : this.props[propName];
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() { }
    attachListeners() {
        const listeners = this.getListeners();
        for (let i = 0, listenersCount = listeners.length; i < listenersCount; i++) {
            const listenersSpec = listeners[i];
            if (listenersSpec.length === 2) {
                // EventListenerSpec
                const type = listenersSpec[0];
                const callback = listenersSpec[1].bind(this);
                this.el.addEventListener(type, callback, false);
            }
            else {
                // DelegateEventListenerSpec
                const [type, delegateSelector, callback] = listenersSpec;
                this.el.addEventListener(type, (e) => {
                    let target = e.target;
                    while (target && target !== this.el && target instanceof Element) {
                        if (matchesSelector(target, delegateSelector)) {
                            const delegateEvent = e;
                            delegateEvent.delegateTarget = target;
                            return callback.call(this, delegateEvent);
                        }
                        target = target.parentElement;
                    }
                }, false);
            }
        }
    }
}
//# sourceMappingURL=Component.js.map